<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <ion-nav [root]="netReqPage" *ngIf="!isConnected"></ion-nav>
  <ion-nav
    [root]="maintenancePage"
    *ngIf="isConnected && maintenanceMode"
  ></ion-nav>
  <ion-loading
    #loading
    class="custom-loading"
    message="Installing latest update..."
  ></ion-loading>
  <ion-modal #updateModal [canDismiss]="false">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Updating VR App</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-progress-bar type="indeterminate"></ion-progress-bar>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-app>
<app-upload-progress
  [position]="{ bottom: 100, right: 10 }"
></app-upload-progress>
<app-upload-indicator></app-upload-indicator>
<app-update-status
  *ngIf="updateAvailable"
  [status]="updateStatus"
></app-update-status>
<app-signature-overlay
  *ngIf="signatureService.visible$ | async"
></app-signature-overlay>
